__webpack_require__.p = "/en-us/business/blueprint/resource-center/";